const orderQueryData = otherEmailOptionEnabled => {
  let options = {
    id: "orderQuery",
    type: "select",
    select: {
      label: "What can we help with?",
      options: [
        {
          value: null,
          label: "Select a subject",
        },
        {
          value: "amendOrder",
          label: "Change an order",
        },
        {
          value: "orderStatusUpdate",
          label: "Order status update",
        },
        {
          value: "cancelOrder",
          label: "Cancel order",
        },
      ],
    },
  };

  if (otherEmailOptionEnabled) {
    const newOptions = [
      {
        value: "orderQueryOther",
        label: "Other",
      },
    ];
    options.select.options = [...options.select.options, ...newOptions];
  }
  return options;
};

export default orderQueryData;
